import script from "./NotificationButton.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationButton.vue?vue&type=script&setup=true&lang=js"

import "./NotificationButton.vue?vue&type=style&index=0&id=20d0cff5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d0cff5"]])

export default __exports__